import { useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'
import { useLangPrefix } from '../../hooks/useLangPrefix'

// "Trả lời nhanh: {title}" under a bot message sent by the Quick Answer pipeline
// (metadata `{source: 'quick_answer', quick_answer_id, quick_answer_title}`); links to that entry.
// The page selects the entry from the `#id`; a deleted entry just opens the list.
// The tag cannot know whether the entry still exists (only the id and title are in the message
// metadata), so it always links; the page shows the "entry no longer exists" notice.
const isQuickAnswerMessage = (message) => message?.metadata?.source === 'quick_answer'

export default function QuickAnswerTag({ message }) {
  const { t } = useTranslation()
  const { prefix } = useLangPrefix()
  if (!isQuickAnswerMessage(message)) return null
  const { quick_answer_id: id, quick_answer_title: title } = message.metadata
  const className = 'mt-0.5 text-[10px] text-blue-700'
  const label = title ? t('inbox.quickAnswerTitled', { title }) : t('inbox.quickAnswer')
  return id
    ? <Link to={`${prefix}/quick-answers#${id}`} className={`${className} underline`}>{label}</Link>
    : <span className={className}>{label}</span>
}
